export default __webpack_public_path__ + "static/media/deppbot.e271988e.svg";